/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiPickerYearStyle = (): Components<Theme>["MuiPickerYear"] => ({
  styleOverrides: {
    yearButton: {
      fontSize: "1rem",
      fontWeight: 400,
    },
  },
});
